module.exports = __webpack_public_path__ + "static/img/1c.88a7728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1c.png
// module id = LxZM
// module chunks = 1